import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useUser() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData, parseErrorResponseData } = useApiResponseParser();

    function useList() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.get(`/v1/user/list`, parameters).then(parseSuccessResponseData),
        });
    }

    function useGetUserById() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.get(`/v1/user/list/${parameters.id}`).then(parseSuccessResponseData),
        });
    }

    function useCreateCognito() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/user/create-cognito`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useList, useGetUserById, useCreateCognito };
}
